/* eslint-disable react/display-name */
/* eslint-disable no-undef */
import React, { memo } from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../common';

interface HeaderProps {
    widgetLocationName: string;
}

const mapStoreStateToProps = (storeState: object) => {
    const { weatherWidget } = storeState || {};
    const { widgetLocationName } = weatherWidget || {};

    return {
        widgetLocationName
    };
};

const mapDispatchToProps = {};

export const Header = reduxConnect( mapStoreStateToProps, mapDispatchToProps )(memo((
    { widgetLocationName } : HeaderProps
) => {
    return (
        <HeaderContainer>{widgetLocationName}</HeaderContainer>
    );
}));

Header.displayName = 'Header';

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-weight: normal;
    font-size: 7vw;
    height: 18%;
`;